import { initializeApp } from 'firebase/app';
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyDBbqQfrrLhQqhGos3x9I1GEoo8RnlMd4M",
    authDomain: "steadfast-c8314.firebaseapp.com",
    projectId: "steadfast-c8314",
    storageBucket: "steadfast-c8314.firebasestorage.app",
    messagingSenderId: "127806935584",
    appId: "1:127806935584:web:3b27ca65cee3c0d1692245",
    measurementId: "G-64HVV0770X"
};

initializeApp(firebaseConfig);

const db = getFirestore();
const auth = getAuth();
export default { db, auth };